// Use this to build GET style params from a JS object:
function buildUrlSearchParams(data) {
  const params = new URLSearchParams();
  Object.keys(data || {}).forEach(k => params.set(k, data[k]));
  return params;
}

export default buildUrlSearchParams;
